import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteUpdatingCart,
} from "@thkStore/Overrides/Store/Data/Carts/Handlers/AddCartLines";
import {
    buildGA4ItemFromCartLine,
    getCurrencyCode,
    trackGA4AddToCart,
} from "@thkStore/Common/Utilities/ga4EcommerceTracking";

const SendGA4AddToCartEvent: typeof DispatchCompleteUpdatingCart = props => {
    if (!props.apiResult?.cartLines?.length) {
        return;
    }

    const state = props.getState();
    const currency = getCurrencyCode(state);
    let totalValue = 0;

    const items = props.apiResult.cartLines.map((line, index) => {
        const price = line.pricing?.unitNetPrice || 0;
        totalValue += price * (line.qtyOrdered || 1);
        return buildGA4ItemFromCartLine(line, { index });
    });

    trackGA4AddToCart(items, currency, totalValue);
};

addToChainAfter(chain, DispatchCompleteUpdatingCart, SendGA4AddToCartEvent);

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
